// src/utils/axios.js
import axios from 'axios'
import { ElMessage } from 'element-plus'

// ==================== 唯一 API 实例：request ====================
const request = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// ==================== 请求拦截器：自动添加 Token ====================
request.interceptors.request.use(
  config => {
    // v2.1 修正：仅跳过【纯公开认证接口】，/auth/users/me/ 必须带 Token
    const isPublicAuthEndpoint = 
      config.url?.includes('/auth/jwt/create/') ||
      config.url?.includes('/auth/jwt/refresh/') ||
      config.url?.includes('/auth/jwt/blacklist/')

    if (!isPublicAuthEndpoint) {
      const token = localStorage.getItem('access_token')
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
    }
    return config
  },
  error => Promise.reject(error)
)

// ==================== 响应拦截器（返回完整 response）================
request.interceptors.response.use(
  response => {
    // 严格遵守 v2.1：返回完整 response，由调用方使用 res?.data || res 提取
    return response
  },
  async error => {
    const originalRequest = error.config

    // 401 Token 过期自动刷新
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const refreshToken = localStorage.getItem('refresh_token')

      if (refreshToken) {
        try {
          const refreshRes = await axios.post('/api/auth/jwt/refresh/', { refresh: refreshToken })
          const newAccessToken = refreshRes.data.access
          localStorage.setItem('access_token', newAccessToken)
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`
          return request(originalRequest)
        } catch (refreshError) {
          handleLogout()
          return Promise.reject(refreshError)
        }
      } else {
        handleLogout()
      }
    }

    let errorMsg = error.response?.data?.detail ||
                   error.response?.data?.non_field_errors?.[0] ||
                   '请求失败，请稍后重试'

    ElMessage.error(errorMsg)
    return Promise.reject(error)
  }
)

// 统一登出处理
const handleLogout = () => {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  ElMessage.warning('登录已过期，请重新登录')
  window.location.href = '/login'
}

export default request